import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { AppDispatch } from '../../store/store';
import { checkIfCandidateToken } from '../../utils/check-if-candidate-token';
import { offerApply } from '../../store/slices/candidateSlice';
import { useTranslation } from 'react-i18next';

const QuickApply = () => {
  const { jobId } = useParams<{ jobId: string }>();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const {t} = useTranslation();

  useEffect(() => {
    if (!jobId) {
      navigate('/candidate');
      return;
    }

    if (checkIfCandidateToken()) {
      // User is logged in, apply directly
      dispatch(offerApply(jobId))
        .unwrap()
        .then(() => {
          toast.success(t('messages.applicationSuccess'));
          navigate(`/candidate/${jobId}`);
        })
        .catch((error: any) => {
          console.log(error.response);
          if(error.message === 'Offer already applied') {
            toast.error(t('errors.alreadyApplied'));
          }
          else{
            toast.error(t('messages.unexpectedError'));
          }
          navigate(`/candidate/${jobId}`);
        });
    } else {
      //user is logged out, redirect to main site with jobId saved
      //application handled in Home.tsx
      sessionStorage.setItem('pendingJobApplication', jobId);
      navigate('/');
    }
  }, [jobId, navigate, dispatch]);

  return <div>Processing your application...</div>;
};

export default QuickApply;